// Protected Higher Level Pages
import { ProtectedPage } from 'src/layout/ProtectedPage/ProtectedPage';
import { SidebarHomeLayout } from 'src/layout/SidebarLayout/SidebarHomeLayout/SidebarHomeLayout';

export const ProtectedPageWithHomeSidebar = (<ProtectedPage><SidebarHomeLayout /></ProtectedPage>);
